import { jsxs, jsx } from "react/jsx-runtime";
const IconDocumentBrokenSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M19.414 7 15 2.586A2.014 2.014 0 0 0 13.586 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h3v-2H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6v2c0 1.654 1.346 3 3 3h2v3h2V8.414c0-.526-.214-1.042-.586-1.414ZM15 6v-.586L16.586 7H16a1 1 0 0 1-1-1Z" }),
      /* @__PURE__ */ jsx("path", { d: "m20 18.586-.086-.086.086-.086 1.707-1.707a1 1 0 1 0-1.414-1.414l-.293.293-1.5 1.5-.5-.5-1.293-1.293a1 1 0 1 0-1.414 1.414l1.793 1.793-1.5 1.5-.293.293a1 1 0 1 0 1.414 1.414l1.793-1.793.885.885.615.615.293.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L20 18.586ZM14 13H9a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2Zm-2 4H9a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z" })
    ]
  }
);
export {
  IconDocumentBrokenSvg
};
